import { withAsyncLoading } from '../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableHomePage = withAsyncLoading(async () => import('./HomePage').then((res) => res.HomePage));

export { LoadableHomePage };
